import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sh-delete-dialog',
  templateUrl: './delete-dialog-v2.component.html',
  styleUrls: ['./delete-dialog-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteDialogV2Component {
  public message: string;
  public title: string;
  public action: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.message = data.message;
    this.title = data.title;
    this.action = data.action || 'Delete';
  }
}
